import type { Action } from 'flow/store/engine/types';
import { isDataRouteExpressionTerm } from './guards';

export function getOutputAttributeDataTypes() {
  return [
    'decimal',
    'integer',
    'string',
  ].sort();
}


export function outputActionHasDataRoutes(action: Action) {
  if (!action.output?.expression) {
    return false;
  }

  // flatten the expression fully to handle nested arrays
  return action.output.expression.flat(Infinity).some(isDataRouteExpressionTerm);
}
